import React from 'react'
import PropTypes from 'prop-types'

function Car({ stopColorStart, stopColorEnd }) {
  return (
    <svg height={28} width={32}>
      <linearGradient id="prefix__a" x1="25.283%" x2="79.917%" y1="17.559%" y2="89.266%">
        <stop offset={0} stopColor={stopColorStart} />
        <stop offset={1} stopColor={stopColorEnd} />
      </linearGradient>
      <path
        d="M30.828 13.414A3.972 3.972 0 0132 16.243V22a1 1 0 01-1 1H1a1 1 0 01-1-1v-5.757c0-1.069.416-2.074 1.172-2.829l1.9-1.9 1.496-8.229A3.999 3.999 0 018.504 0h14.992a3.999 3.999 0 013.936 3.285l1.496 8.229zM6.536 3.642L5.198 11h21.604l-1.338-7.358A1.999 1.999 0 0023.496 2H8.504c-.967 0-1.795.69-1.968 1.642zM6.5 19a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 006.5 19zm19 0a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 0025.5 19zM2 25h7v2a1 1 0 01-1 1H3a1 1 0 01-1-1zm21 0h7v2a1 1 0 01-1 1h-5a1 1 0 01-1-1z"
        fill="url(#prefix__a)"
        fillRule="evenodd"
      />
    </svg>
  )
}

Car.defaultProps = {
  stopColorStart: '#2382cd',
  stopColorEnd: '#005b9e'
}

Car.propTypes = {
  stopColorStart: PropTypes.string,
  stopColorEnd: PropTypes.string
}

export default Car
